/** Account types allowed to access the admin dashboard */
const ALLOWED_ACCOUNT_TYPES: string[] = ['admin'];

/**
 * Checks if the given account type is allowed to access the admin dashboard.
 */
export const isAllowedAccountType = (accountType: string): boolean => {
  return ALLOWED_ACCOUNT_TYPES.includes(accountType);
};
